<template>
  <div>
    <div 
      v-for="(item, itemIndex) in items"
      :key="itemIndex"
      class="lv-state-multilayer"
    >
      <div  
        class="lv-state-multilayer__title"
        :class="{'no-subLayers': !item[`${layerKey}`].length}"
        @click="$_onToggleDropdown($event, item.id, itemIndex, item.disable)"
      >
        <i 
          v-if="item[`${layerKey}`] && item[`${layerKey}`].length"
          class="lv-state-multilayer__chevron-icon icon-chevron-up"
          :class="{show: isActive.dropdownList[itemIndex]}"
        />
        <i
          class="lv-state-multilayer__checkbox-icon"
          :class="[`${$_getCheckboxIcon(item.id)}`, {disable: item.disable}]"
        />
        <p class="lv-state-multilayer__text" :class="{disable: item.disable}" >
          {{ item[`${textKey}`] }}
        </p>
      </div>
      <LvStateMultiLayer
        v-if="item[`${layerKey}`] && isActive.dropdownList[itemIndex]"
        :value="value"
        :items="item[`${layerKey}`]"
        :layerKey="layerKey"
        @input="$_onClickSubItem($event)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "LvStateMultiLayer",
  props: {
    items: {
      type: Array,
      required: true
    },
    value: {
      type: Array,
    },
    textKey: {
      type: String,
      default: "name",
    },
    layerKey: {
      type: String,
      default: "items",
    }
  },
  data() {
    return {
      isActive: {
        dropdownList: []
      }
    }
  },
  mounted(){
    this.$_init()
  },
  methods: {
    $_init() {
      this.items.forEach(() => {
        this.isActive.dropdownList.push(false)
      })
    },
    $_onClickSubItem($event) {
      this.$emit("input", $event)
    },
    $_onClickItem(selectedId) {
      const value = [...this.value]
      const tarIndex = value.findIndex((id) => id == selectedId)
      if (tarIndex >= 0) {
        value.splice(tarIndex, 1)
      } else {
        value.push(selectedId)
      }
      this.$emit("input", value)
    },
    $_getCheckboxIcon(itemId) {
      const isItemSelected = this.value.includes(itemId);
      if (isItemSelected) {
        return "icon-check-box";
      } else{
        return "icon-check-box-outline-blank";
      }
    },
    $_onToggleDropdown($event, tarItemId, tarItemIndex, disable) {
      const clickTarget = $event.target
      const isSelectItem = 
        clickTarget.className.includes("lv-state-multilayer__checkbox-icon") ||
        clickTarget.className.includes("lv-state-multilayer__text");
      if (isSelectItem && disable) return;
      if (isSelectItem) {
        this.$_onClickItem(tarItemId)
      } else {
        this.$set(
          this.isActive.dropdownList,
          tarItemIndex,
          !this.isActive.dropdownList[tarItemIndex]
        )
      }
    }
  },
}
</script>